//
//
//
//
//
//

import { setOwnKey } from '@/tools'
export default {
  props: {},
  data() {
    return {
      question: {
        v_ownId: setOwnKey(),
        v_active: false,
        v_label: '单选题',
        type: 'radio',
        displayIndex: true,
        title: '请选择一个选项',
        required: true,
        voteVisible: false,
        column: 1,
        uploadArrow: true,
        uploadArrowRequired: false,
        logic: {
          blocks: {
            typeBlock: 'all',
            list: [],
          },
        },
        options: [
          {
            v_ownId: setOwnKey(),
            v_editable: false,
            text: '选项1',
            score: 0,
            blankVisible: false,
            blankRule: 'ignore',
            blankMaxLengthVisible: false,
            blankMinLength: null,
            blankMaxLength: null,
            blankRequired: false,
          },
          {
            v_ownId: setOwnKey(),
            v_editable: false,
            text: '选项2',
            score: 0,
            blankVisible: false,
            blankRule: 'ignore',
            blankMaxLengthVisible: false,
            blankMinLength: null,
            blankMaxLength: null,
            blankRequired: false,
          },
        ],
      },
    }
  },
  methods: {
    chooseItem() {
      this.$emit('choose', this.question)
    },
  },
}
